import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, FileText } from "lucide-react";

const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 backdrop-blur-md bg-[#0b1626]/70 border-b border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="navbar-logo-link">
          <div className="w-9 h-9 rounded-full relative overflow-hidden shadow-lg" style={{
            background: "linear-gradient(180deg,#ee1515 0 49%, #1a1a1a 49% 53%, #f5f5f5 53% 100%)"
          }}>
            <span className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-3 h-3 rounded-full bg-white border-2 border-[#1a1a1a]" />
          </div>
          <span className="pixel-font text-[#ffcb05] text-sm tracking-wider">POKÉREALMS</span>
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm">
          <a href="/#features" className="text-white/70 hover:text-[#ffcb05] transition-colors">Features</a>
          <a href="/#showcase" className="text-white/70 hover:text-[#ffcb05] transition-colors">Showcase</a>
          <a href="/#tech" className="text-white/70 hover:text-[#ffcb05] transition-colors">Tech Stack</a>
          <Link to="/documents" className="text-white/70 hover:text-[#ffcb05] transition-colors" data-testid="navbar-documents-link">Documents</Link>
        </nav>

        <div className="flex items-center gap-3">
          <a href="https://x.com/pokerealmsfun" target="_blank" rel="noreferrer" className="hidden sm:inline-flex items-center gap-2 text-white/70 hover:text-[#ffcb05] text-sm transition-colors">
            <span className="font-bold text-base">𝕏</span> @pokerealmsfun
          </a>
          <Link to="/play" className="press-start pixel-font text-[10px] sm:text-xs px-4 py-2.5 rounded">
            PLAY
          </Link>
          <button
            onClick={() => setOpen((v) => !v)}
            className="md:hidden inline-flex items-center justify-center w-9 h-9 rounded text-white/80 hover:text-[#ffcb05] border border-white/10"
            aria-label="Toggle menu"
            data-testid="navbar-hamburger-button"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/10 bg-[#0b1626]/95 backdrop-blur-md" data-testid="navbar-mobile-menu">
          <nav className="flex flex-col px-6 py-4 gap-1 text-sm">
            <a href="/#features" onClick={() => setOpen(false)} className="py-3 text-white/75 hover:text-[#ffcb05] transition-colors border-b border-white/5">Features</a>
            <a href="/#showcase" onClick={() => setOpen(false)} className="py-3 text-white/75 hover:text-[#ffcb05] transition-colors border-b border-white/5">Showcase</a>
            <a href="/#tech" onClick={() => setOpen(false)} className="py-3 text-white/75 hover:text-[#ffcb05] transition-colors border-b border-white/5">Tech Stack</a>
            <Link to="/documents" onClick={() => setOpen(false)} className="py-3 text-[#ffcb05] hover:text-[#ffcb05] transition-colors flex items-center gap-2" data-testid="navbar-mobile-documents-link">
              <FileText size={16} /> Documents
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Navbar;
